<template>
  <div class="copyright-area bg-primary">
    <div class="container">
      <div class="row">
        <p>
          © <span>GoPlayTv</span> 
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CopyRight",
});
</script>
